export default "__VITE_ASSET__DBg3L4pq__"